import { defineComponent as _defineComponent } from 'vue'
import { TmButtonTypes } from '@/ui/tm-button/tm-button.types'
import TmIcon from '@/ui/tm-icon/tm-icon.vue'
import { Icon } from '@/ui/tm-icon/tm-icons.types'

interface Props {
    type: TmButtonTypes
    text?: string
    icon?: Icon
    loading?: boolean
    disabled?: boolean
    attention?: boolean
    white?: boolean
    href?: string
    small?: boolean
    to?: string | { name: string }
    ariaLabel?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'tm-button',
  props: {
    type: null,
    text: null,
    icon: null,
    loading: { type: Boolean },
    disabled: { type: Boolean },
    attention: { type: Boolean },
    white: { type: Boolean },
    href: null,
    small: { type: Boolean },
    to: null,
    ariaLabel: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
    type: TmButtonTypes
    text?: string
    icon?: Icon
    loading?: boolean
    disabled?: boolean
    attention?: boolean
    white?: boolean
    href?: string
    small?: boolean
    to?: string | { name: string }
    ariaLabel?: string
}




const color = () => {
    if (props.white) {
        return 'white'
    }

    return props.attention ? 'red' : 'primary'
}
const isOutlined = () => props.type === 'secondary'
const isText = () => props.type === 'tertiary'
const iconColor = () => {
    if (props.white) {
        return props.type === 'primary' ? 'primary' : 'white'
    }

    if (props.attention && props.type !== 'primary') {
        return 'red'
    }

    return props.type === 'primary' ? 'white' : 'primary'
}
const hasIcon = (): boolean => !!props.icon
const classes = (): string | undefined => {
    if (props.white) {
        return props.type === 'secondary' ? 'white--text' : 'primary--text'
    }

    return props.attention ? 'white--text' : undefined
}
const hasText = (): boolean => !!props.text
const isIcon = (): boolean => props.type === 'tertiary' && !hasText() && hasIcon()
const isIconLeft = () => hasText()
const target = (): string | undefined => props.href ? '_blank' : undefined

function onClick (event: PointerEvent) {
    emit('click', event)
}

return { __sfc: true,props, emit, color, isOutlined, isText, iconColor, hasIcon, classes, hasText, isIcon, isIconLeft, target, onClick, TmIcon }
}

})